import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../api';

/* ─────────────────────────────────────────────────────────────────────────────
   Messages.js — redesigned with light theme matching Profile.js
───────────────────────────────────────────────────────────────────────────── */

const B = '#1c73ba';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
:root{--blue:#1c73ba;--bl:#e8f3fb;--bd:#155fa0;--text:#111827;--muted:#6b7280;--border:#e5e7eb;--bg:#f3f4f6;--red:#ef4444;--green:#10b981;--gold:#f59e0b}
*{box-sizing:border-box;margin:0;padding:0}
.msg-root{display:flex;flex-direction:column;height:100dvh;background:var(--bg);font-family:'Inter',system-ui,sans-serif;color:var(--text);-webkit-font-smoothing:antialiased}
/* nav handled by shared Navbar component */
.ic-btn{width:34px;height:34px;border:1px solid var(--border);border-radius:8px;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--muted);transition:all .15s;flex-shrink:0}
.ic-btn:hover{border-color:var(--blue);color:var(--blue);background:var(--bl)}
.msg-layout{flex:1;display:flex;overflow:hidden;min-height:0}
/* sidebar */
.msg-sidebar{width:300px;border-right:1px solid var(--border);display:flex;flex-direction:column;background:#fff;flex-shrink:0}
@media(max-width:700px){.msg-sidebar{width:100%}.msg-sidebar.hidden{display:none}}
.msg-sidebar-head{padding:14px 16px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-shrink:0}
.msg-sidebar-title{font-size:15px;font-weight:700;color:var(--text)}
.msg-new-btn{display:flex;align-items:center;gap:5px;padding:6px 12px;border:none;border-radius:8px;background:var(--blue);color:#fff;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;transition:background .15s}
.msg-new-btn:hover{background:var(--bd)}
.msg-list{flex:1;overflow-y:auto}
.msg-convo{display:flex;align-items:center;gap:10px;padding:12px 14px;cursor:pointer;transition:background .15s;border-bottom:1px solid #f9fafb;border-left:2px solid transparent}
.msg-convo:hover{background:#f9fafb}
.msg-convo.active{background:var(--bl);border-left-color:var(--blue)}
.msg-convo-name{font-size:14px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}
.msg-convo-name.unread{font-weight:700}
.msg-convo-preview{font-size:12px;color:var(--muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}
.msg-convo-time{font-size:11px;color:var(--muted);flex-shrink:0}
.msg-badge{background:var(--blue);color:#fff;font-size:10px;font-weight:700;border-radius:99px;min-width:18px;height:18px;padding:0 4px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
/* chat pane */
.msg-chat{flex:1;display:flex;flex-direction:column;min-width:0;background:#fff}
@media(max-width:700px){.msg-chat.hidden{display:none}}
.msg-chat-head{padding:12px 16px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;flex-shrink:0}
.msg-chat-name{font-size:14px;font-weight:700;color:var(--text)}
.msg-chat-link{font-size:11px;color:var(--blue);text-decoration:none}
.msg-chat-link:hover{text-decoration:underline}
.msg-messages{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:2px}
.msg-day{text-align:center;margin:10px 0;font-size:11px;color:var(--muted);font-weight:600}
.msg-bubble-row{display:flex;align-items:flex-end;gap:6px}
.msg-bubble-row.mine{justify-content:flex-end}
.msg-bubble{padding:9px 13px;border-radius:16px;max-width:72%;font-size:14px;line-height:1.5;word-break:break-word}
.msg-bubble.mine{background:var(--blue);color:#fff;border-radius:16px 16px 4px 16px}
.msg-bubble.theirs{background:#f3f4f6;color:var(--text);border-radius:16px 16px 16px 4px}
.msg-bubble-meta{font-size:10px;color:var(--muted);margin-top:3px;text-align:right}
.msg-bubble-meta.theirs{text-align:left}
.msg-input-wrap{padding:10px 14px;border-top:1px solid var(--border);display:flex;gap:8px;align-items:flex-end;flex-shrink:0;background:#fff}
.msg-textarea{flex:1;background:#f3f4f6;border:1.5px solid var(--border);border-radius:12px;padding:10px 14px;color:var(--text);font-size:14px;outline:none;resize:none;max-height:120px;overflow-y:auto;font-family:'Inter',sans-serif;line-height:1.5;transition:border .15s}
.msg-textarea:focus{border-color:var(--blue);background:#fff}
.msg-send{width:40px;height:40px;border-radius:10px;border:none;flex-shrink:0;background:var(--blue);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s}
.msg-send:disabled{background:#e5e7eb;color:#9ca3af;cursor:default}
.msg-send:not(:disabled):hover{background:var(--bd)}
.msg-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;color:var(--muted);padding:40px}
/* modal */
.msg-modal-bg{position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px)}
.msg-modal{background:#fff;border-radius:16px;width:min(460px,96vw);max-height:85vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.15);overflow:hidden}
.msg-modal-head{padding:18px 20px;border-bottom:1px solid var(--border);flex-shrink:0}
.msg-modal-title{font-size:15px;font-weight:700;color:var(--text);margin-bottom:12px}
.msg-tab{padding:6px 14px;border-radius:99px;border:1px solid var(--border);background:#fff;font-size:12px;font-weight:600;color:var(--muted);cursor:pointer;font-family:inherit;transition:all .15s}
.msg-tab:hover{border-color:var(--blue);color:var(--blue)}
.msg-tab.sel{background:var(--bl);border-color:var(--blue);color:var(--blue)}
.msg-search-wrap{position:relative;margin-top:10px}
.msg-search-icon{position:absolute;left:11px;top:50%;transform:translateY(-50%);color:var(--muted);pointer-events:none}
.msg-search{width:100%;padding:9px 12px 9px 34px;border:1.5px solid var(--border);border-radius:9px;font-size:13px;color:var(--text);outline:none;font-family:inherit;background:#f9fafb;transition:border .15s}
.msg-search:focus{border-color:var(--blue);background:#fff}
.msg-modal-list{flex:1;overflow-y:auto}
.msg-user-row{display:flex;align-items:center;gap:10px;padding:12px 18px;cursor:pointer;transition:background .15s;border-bottom:1px solid #f9fafb}
.msg-user-row:hover{background:#f9fafb}
.msg-user-name{font-size:14px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.msg-user-sub{font-size:11px;color:var(--muted);margin-top:1px}
.msg-hint{font-size:12px;color:var(--muted);text-align:center;padding:20px}
.msg-spinner{width:16px;height:16px;border:2px solid var(--bl);border-top-color:var(--blue);border-radius:50%;animation:spin .7s linear infinite;display:inline-block}
@keyframes spin{to{transform:rotate(360deg)}}
::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:99px}
`;

// Icons
const Ic = {
  back:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  compose: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  send:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  search:  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  x:       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  msg:     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  ext:     <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
};

function Avatar({ name, photo, size = 38 }) {
  const initials = (name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  const hue = [...(name || '')].reduce((a, c) => a + c.charCodeAt(0), 0) % 360;
  return photo
    ? <img src={photo} alt={name} style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}/>
    : <div style={{ width: size, height: size, borderRadius: '50%', background: `hsl(${hue},50%,42%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: size * 0.35, flexShrink: 0 }}>{initials}</div>;
}

function timeLabel(date) {
  if (!date) return '';
  const d = new Date(date), now = new Date(), diff = now - d;
  if (diff < 60000) return 'now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m`;
  if (d.toDateString() === now.toDateString()) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return d.toLocaleDateString([], { day: 'numeric', month: 'short' });
}

function dayLabel(date) {
  const d = new Date(date), now = new Date();
  if (d.toDateString() === now.toDateString()) return 'Today';
  const y = new Date(now); y.setDate(now.getDate() - 1);
  if (d.toDateString() === y.toDateString()) return 'Yesterday';
  return d.toLocaleDateString([], { weekday: 'long', day: 'numeric', month: 'long' });
}

// ── New conversation modal ────────────────────────────────────────────────────
function NewConvoModal({ onClose, onStart }) {
  const [tab,     setTab]     = useState('search'); // search | contacts | direct
  const [q,       setQ]       = useState('');
  const [results, setResults] = useState([]);
  const [contacts,setContacts]= useState([]);
  const [loading, setLoading] = useState(false);
  const [flapId,  setFlapId]  = useState('');
  const timer = useRef(null);

  useEffect(() => {
    api.get('/contacts?limit=50').then(r => setContacts((r.data.contacts || []).filter(c => c.flapUserId))).catch(() => {});
  }, []);

  const doSearch = async (v) => {
    if (!v.trim() || v.length < 2) { setResults([]); return; }
    setLoading(true);
    try {
      const { data } = await api.get(`/messages/search-users?q=${encodeURIComponent(v)}`);
      setResults(data.users || []);
    } catch {}
    setLoading(false);
  };

  const handleQ = v => { setQ(v); clearTimeout(timer.current); timer.current = setTimeout(() => doSearch(v), 300); };

  const sendDirect = () => { if (flapId.trim()) onStart({ directFlapId: flapId.trim() }); };

  const filteredContacts = contacts.filter(c =>
    !q || c.name?.toLowerCase().includes(q.toLowerCase()) || c.flapId?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="msg-modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="msg-modal">
        <div className="msg-modal-head">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="msg-modal-title">New message</div>
            <button className="ic-btn" onClick={onClose}>{Ic.x}</button>
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <button className={`msg-tab ${tab === 'search' ? 'sel' : ''}`} onClick={() => { setTab('search'); setQ(''); setResults([]); }}>Search users</button>
            <button className={`msg-tab ${tab === 'contacts' ? 'sel' : ''}`} onClick={() => setTab('contacts')}>My contacts ({contacts.length})</button>
            <button className={`msg-tab ${tab === 'direct' ? 'sel' : ''}`} onClick={() => setTab('direct')}>By FlapID</button>
          </div>
          {tab !== 'direct' && (
            <div className="msg-search-wrap">
              <span className="msg-search-icon">{Ic.search}</span>
              <input className="msg-search" autoFocus value={q} onChange={e => tab === 'search' ? handleQ(e.target.value) : setQ(e.target.value)}
                placeholder={tab === 'search' ? 'Search by username or FlapID…' : 'Filter contacts…'}/>
            </div>
          )}
          {tab === 'direct' && (
            <div style={{ marginTop: 10 }}>
              <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>Send a message directly to any FlapID or username.</p>
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="msg-search" style={{ paddingLeft: 12, flex: 1 }} autoFocus value={flapId}
                  onChange={e => setFlapId(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendDirect()}
                  placeholder="FlapID or username…"/>
                <button onClick={sendDirect} disabled={!flapId.trim()}
                  style={{ padding: '9px 14px', borderRadius: 9, border: 'none', background: B, color: '#fff', fontWeight: 700, fontSize: 13, cursor: flapId.trim() ? 'pointer' : 'default', opacity: flapId.trim() ? 1 : 0.5, fontFamily: 'inherit' }}>
                  Send
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="msg-modal-list">
          {tab === 'search' && loading && <div className="msg-hint"><span className="msg-spinner"/></div>}
          {tab === 'search' && !loading && q.length < 2 && <div className="msg-hint">Type at least 2 characters to search</div>}
          {tab === 'search' && !loading && q.length >= 2 && results.length === 0 && <div className="msg-hint">No users found for "{q}"</div>}
          {tab === 'contacts' && contacts.length === 0 && <div className="msg-hint">No Flap contacts yet — use Search Users</div>}

          {(tab === 'search' ? results : filteredContacts).map(item => {
            const isUser = tab === 'search';
            const name = isUser ? item.username : item.name;
            const photo = isUser ? item.user_photo : item.photo;
            const sub = isUser ? (item.primaryFlapid ? `@${item.primaryFlapid}` : '') : (item.organization || '');
            return (
              <div key={item._id} className="msg-user-row" onClick={() => onStart(item)}>
                <Avatar name={name || '?'} photo={photo} size={40}/>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="msg-user-name">{name || '—'}</div>
                  {sub && <div className="msg-user-sub">{sub}</div>}
                </div>
                <span style={{ fontSize: 12, color: B, fontWeight: 600 }}>Message</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── Conversation list ─────────────────────────────────────────────────────────
function ConvoList({ convos, activeId, onSelect, onNew }) {
  return (
    <>
      <div className="msg-sidebar-head">
        <span className="msg-sidebar-title">Messages</span>
        <button className="msg-new-btn" onClick={onNew}>{Ic.compose} New</button>
      </div>
      <div className="msg-list">
        {!convos.length && (
          <div className="msg-hint" style={{ paddingTop: 40 }}>
            <div style={{ marginBottom: 8 }}>{Ic.msg}</div>
            No messages yet
          </div>
        )}
        {convos.map(c => (
          <div key={c._id} className={`msg-convo ${activeId === c._id ? 'active' : ''}`} onClick={() => onSelect(c)}>
            <Avatar name={c.peer?.username || '?'} photo={c.peer?.user_photo} size={42}/>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <span className={`msg-convo-name ${c.myUnread > 0 ? 'unread' : ''}`}>{c.peer?.username || 'Unknown'}</span>
                <span className="msg-convo-time">{timeLabel(c.lastMessage?.timestamp)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <span className="msg-convo-preview">{c.lastMessage?.text || 'No messages yet'}</span>
                {c.myUnread > 0 && <span className="msg-badge">{c.myUnread > 9 ? '9+' : c.myUnread}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

// ── Chat window ───────────────────────────────────────────────────────────────
function ChatWindow({ convoId, myId, onBack }) {
  const [messages, setMessages] = useState([]);
  const [peer,     setPeer]     = useState(null);
  const [text,     setText]     = useState('');
  const [loading,  setLoading]  = useState(true);
  const [sending,  setSending]  = useState(false);
  const bottomRef = useRef(null);
  const inputRef  = useRef(null);
  const pollRef   = useRef(null);

  const load = useCallback(async (before = null) => {
    try {
      const url = `/messages/conversations/${convoId}${before ? `?before=${before}` : ''}`;
      const { data } = await api.get(url);
      if (before) setMessages(p => [...data.messages, ...p]);
      else { setMessages(data.messages); setPeer(data.peer); }
    } catch {}
    setLoading(false);
  }, [convoId]);

  useEffect(() => {
    setLoading(true); setMessages([]); load();
    pollRef.current = setInterval(() => load(), 4000);
    return () => clearInterval(pollRef.current);
  }, [load]);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages.length]);

  const send = async () => {
    const t = text.trim();
    if (!t || sending) return;
    setText(''); setSending(true);
    try { await api.post('/messages/send', { recipientId: peer?._id, text: t }); await load(); } catch {}
    setSending(false);
    inputRef.current?.focus();
  };

  // Group by day
  const grouped = [];
  let lastDay = null;
  messages.forEach(m => {
    const day = new Date(m.createdAt).toDateString();
    if (day !== lastDay) { grouped.push({ type: 'day', label: dayLabel(m.createdAt), key: day }); lastDay = day; }
    grouped.push({ type: 'msg', ...m });
  });

  return (
    <>
      <div className="msg-chat-head">
        <button className="ic-btn" onClick={onBack}>{Ic.back}</button>
        {peer && <Avatar name={peer.username} photo={peer.user_photo} size={36}/>}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="msg-chat-name">{peer?.username || '…'}</div>
          {peer?.primaryFlapid && (
            <a href={`/${peer.primaryFlapid}`} target="_blank" rel="noreferrer" className="msg-chat-link">
              View profile {Ic.ext}
            </a>
          )}
        </div>
      </div>

      <div className="msg-messages">
        {loading && <div style={{ textAlign: 'center', color: '#9ca3af', paddingTop: 40 }}><span className="msg-spinner"/></div>}
        {!loading && messages.length >= 50 && (
          <div style={{ textAlign: 'center', marginBottom: 12 }}>
            <button className="ic-btn" style={{ width: 'auto', padding: '5px 14px', fontSize: 12 }}
              onClick={() => load(messages[0]?.createdAt)}>Load older</button>
          </div>
        )}
        {grouped.map((item, i) => {
          if (item.type === 'day') return (
            <div key={item.key} className="msg-day">{item.label}</div>
          );
          const mine = item.senderId?.toString() === myId;
          const isRead = mine && item.readBy?.length > 1;
          return (
            <div key={item._id || i}>
              <div className={`msg-bubble-row ${mine ? 'mine' : ''}`}>
                {!mine && <Avatar name={peer?.username} photo={peer?.user_photo} size={28}/>}
                <div>
                  <div className={`msg-bubble ${mine ? 'mine' : 'theirs'}`}>{item.text}</div>
                  <div className={`msg-bubble-meta ${mine ? '' : 'theirs'}`}>
                    {timeLabel(item.createdAt)}{mine && ` · ${isRead ? '✓✓' : '✓'}`}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div ref={bottomRef}/>
      </div>

      <div className="msg-input-wrap">
        <textarea ref={inputRef} className="msg-textarea" value={text} rows={1}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Message… (Enter to send)"/>
        <button className="msg-send" onClick={send} disabled={!text.trim() || sending}>
          {sending ? <span className="msg-spinner" style={{ width: 14, height: 14, borderWidth: 1.5 }}/> : Ic.send}
        </button>
      </div>
    </>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function Messages() {
  const navigate = useNavigate();
  const location = useLocation();
  const [convos,  setConvos]  = useState([]);
  const [active,  setActive]  = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(true);
  const myId = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    try { const p = JSON.parse(atob(token.split('.')[1])); myId.current = p.id; } catch { navigate('/login'); }
  }, [navigate]);

  const loadConvos = useCallback(async () => {
    try {
      const { data } = await api.get('/messages/conversations');
      setConvos(data.conversations);
      const openWith = location.state?.openConvoWith;
      if (openWith) {
        try {
          const { data: sent } = await api.post('/messages/send', { recipientId: openWith, text: '👋' });
          const { data: fresh } = await api.get('/messages/conversations');
          setConvos(fresh.conversations);
          const convo = fresh.conversations.find(c => c._id === sent.conversationId?.toString());
          if (convo) setActive(convo);
        } catch {}
        window.history.replaceState({}, '');
      }
    } catch { if (!localStorage.getItem('token')) navigate('/login'); }
    setLoading(false);
  }, [navigate, location.state]);

  useEffect(() => { loadConvos(); }, [loadConvos]);

  useEffect(() => {
    const id = setInterval(async () => {
      try { const { data } = await api.get('/messages/conversations'); setConvos(data.conversations); } catch {}
    }, 8000);
    return () => clearInterval(id);
  }, []);

  const startNewConvo = async (item) => {
    setShowNew(false);
    try {
      let body;
      if (item.directFlapId)   body = { recipientFlapId: item.directFlapId, text: '👋' };
      else if (item.flapUserId) body = { recipientId: item.flapUserId, text: '👋' };
      else if (item._id)        body = { recipientId: item._id, text: '👋' };
      else return;
      const { data } = await api.post('/messages/send', body);
      const { data: fresh } = await api.get('/messages/conversations');
      setConvos(fresh.conversations);
      const convo = fresh.conversations.find(c => c._id === data.conversationId?.toString());
      if (convo) setActive(convo);
    } catch (e) { console.error('[Messages]', e.response?.data?.error || e.message); loadConvos(); }
  };

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 700;
  const unreadTotal = convos.reduce((s, c) => s + (c.myUnread || 0), 0);

  return (
    <div className="msg-root">
      <style>{CSS}</style>
      <Navbar/>

      <div className="msg-layout">
        <div className={`msg-sidebar ${active && isMobile ? 'hidden' : ''}`}>
          {loading
            ? <div className="msg-hint" style={{ paddingTop: 60 }}><span className="msg-spinner"/></div>
            : <ConvoList convos={convos} activeId={active?._id} onSelect={setActive} onNew={() => setShowNew(true)}/>
          }
        </div>

        <div className={`msg-chat ${!active && isMobile ? 'hidden' : ''}`}>
          {active
            ? <ChatWindow key={active._id} convoId={active._id} myId={myId.current} onBack={() => setActive(null)}/>
            : <div className="msg-empty">
                <div style={{ color: '#d1d5db' }}>{Ic.msg}</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#374151' }}>Select a conversation</div>
                <div style={{ fontSize: 13 }}>or start a new one</div>
                <button style={{ marginTop: 8, padding: '9px 20px', borderRadius: 10, border: 'none', background: B, color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}
                  onClick={() => setShowNew(true)}>{Ic.compose} New message</button>
              </div>
          }
        </div>
      </div>

      {showNew && <NewConvoModal onClose={() => setShowNew(false)} onStart={startNewConvo}/>}
    </div>
  );
}